import type { ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useShippingBoIntegrationConnectionRedirect(
  shop: ShopDto,
) {
  const invalidateShop = useInvalidateShop(shop.id);

  return useApiMutation<"post", "/shops/{shopId}/integrations/shippingbo/auth", void>(
    "post",
    "/shops/{shopId}/integrations/shippingbo/auth",
    {
      invalidate: invalidateShop,
      onSuccess: (result) => {
        window.location.href = decodeURIComponent(result);
      },
      mapVariables: () => ({
        params: { path: { shopId: shop.id } },
      }),
    },
  );
}
